import { Component, OnDestroy, OnInit } from '@angular/core';
import { ColmecWorkingOrderStepComponent } from '../colmec-working-order-step/colmec-working-order-step.component';
import { ActivatedRoute } from '@angular/router';
import { ColmecWorkingOrderService } from '../../../../services/colmec-working-order.service';
import { Subject, first, forkJoin, of, switchMap, takeUntil } from 'rxjs';
import { ColmecWorkOrder } from '../../colmec-working-order-wrapper/colmec-working-order-wrapper.component';
import { SelectedCustomerService } from 'gung-standard';
import { ColmecPartnerAgreementsService } from 'projects/colmec/src/app/services/colmec-partner-agreements.service';

@Component({
    selector: 'colmec-init-working-order-object-step',
    templateUrl: './colmec-init-working-order-object-step.component.html',
    styleUrls: ['./colmec-init-working-order-object-step.component.scss'],
    standalone: false
})
export class ColmecInitWorkingOrderObjectStepComponent extends ColmecWorkingOrderStepComponent implements OnInit, OnDestroy {
  protected defaultWorkingOrder: ColmecWorkOrder = {
    id: undefined,
    name: null,
    extra: {},
    agreementId: '',
    workPerformedDate: new Date(),
    regNr: '',
    reasonForWork: '',
    tires: [],
    services: [],
    extras: []
  };

  protected unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    protected route: ActivatedRoute,
    protected workingOrderService: ColmecWorkingOrderService,
    protected partneerAgreementService: ColmecPartnerAgreementsService,
    protected selectedCustomerService: SelectedCustomerService
  ) {
    super();
  }

  ngOnInit() {
    this.onNextBtnClicked.subscribe(() => {
      if (this.route.snapshot.params.id) {
        this.workingOrderService.getWorkingOrder(this.route.snapshot.params.id, true).pipe(
          first(),
          switchMap(workingOrder => forkJoin({
            workingOrder: of(workingOrder),
            partneerAgreement: this.partneerAgreementService.getPartnerAgreementById(workingOrder?.agreementId)
          }))
        ).subscribe(({ workingOrder, partneerAgreement }) => {
          if (!!workingOrder && !!partneerAgreement) {
            this.selectedCustomerService.selectCustomer(partneerAgreement.partnerId);
            this.selectedCustomerService.getSelectedCustomer().pipe(takeUntil(this.unsubscribe)).subscribe(selectedCustomer => {
              if (selectedCustomer.id === partneerAgreement.partnerId) {
                this.stepDone.emit(workingOrder);
              }
            });
          } else {
            this.stepDone.emit(this.defaultWorkingOrder);
          }
        });
      } else {
        this.stepDone.emit(this.defaultWorkingOrder);
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public isVisible() {
    return false;
  }
}
